import { useEffect, useState, useCallback } from 'react';
import * as sentry from "@sentry/react";
import { FileListItem } from '@artprov/design-system';
import { getArchivosFactura, descargarArchivoFactura } from '../../../services/compra.services';

export default function FileDownloadList({ idComprobante }) {
  const [files, setFiles] = useState([]);

  const fetchArchivos = useCallback(async () => {
    if (!idComprobante) return;
    
    try {
      const response = await getArchivosFactura(idComprobante);
      
      const archivosArray = response?.data || [];
      
      const transformedFiles = archivosArray
        .filter(archivo => archivo?.location)
        .map(archivo => {
          const { location, nombre, audit } = archivo;
          
          let fileType = 'pdf';
          if (nombre) {
            const extension = nombre.split('.').pop()?.toLowerCase();
            if (extension && ['pdf', 'xlsx', 'xls', 'doc', 'docx', 'mp4'].includes(extension)) {
              fileType = extension;
            }
          }
          
          if (location.url && (location.url.includes('drive.google.com') || 
              location.url.includes('http') && !location.url.includes('desa.apigateway.artprovincia.com.ar'))) {
            fileType = 'html';
          }
          
          let fileDate = null;
          if (audit?.alta?.fecha) {
            fileDate = audit.alta.fecha.split('T')[0];
          }
          
          return {
            fileName: nombre || 'Documento',
            fileType: fileType,
            fileDate: fileDate,
            _originalData: {
              idArchivo: location.idArchivo,
              ruta: location.ruta,
              url: location.url
            }
          };
        });
      
      setFiles(transformedFiles);
    } catch (err) {
      sentry.captureException(err);
    }
  }, [idComprobante]);

  useEffect(() => {
    fetchArchivos();
  }, [fetchArchivos]);

  const handleFileClick = async (file) => {
    try {
      const originalData = file._originalData;
      const { idArchivo, ruta, url } = originalData;
      
      if (url && (url.includes('drive.google.com') || 
          (url.includes('http') && !url.includes('artprovincia.com.ar')))) {
        window.open(url, '_blank');
        return;
      }
      
      if (url && url.includes('artprovincia.com.ar')) {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Error al descargar el archivo desde la URL');
        }
        
        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = file.fileName || 'documento.pdf';
        
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
          if (filenameMatch?.[1]) {
            filename = filenameMatch[1];
          }
        }
        
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        return;
      }
      
      let downloadParams = {};
      
      if (idArchivo && idArchivo > 0) {
        downloadParams.idarchivo = idArchivo;
      } else if (ruta) {
        downloadParams.path = ruta;
      } else {
        console.error('No se encontró idArchivo, ruta ni url para el archivo');
        return;
      }

      console.log('Descargando archivo con parámetros:', downloadParams);
      const { blob, filename } = await descargarArchivoFactura(downloadParams);
      
      const finalFilename = (filename && filename !== 'archivo_descargado') 
        ? filename 
        : file.fileName || 'documento.pdf';
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = finalFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
    } catch (err) {
      console.error('Error al descargar archivo:', err);
      sentry.captureException(err);
    }
  };

  if (!files || files.length === 0) {
    return null;
  }

  return (
    <div className="w-full mb-10">      
      <FileListItem 
        files={files} 
        onFileClick={handleFileClick}
        distance={250}
        maxItems={6}
      />
    </div>
  );
}
